const SD = {
  sidebar: {
    width: '220px',
    minWidth: '220px',
    backgroundColor: 'var(--color-surface)',
    borderRight: '1px solid var(--color-border)',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflowY: 'auto',
  },
  sidebarTitle: {
    fontSize: '11px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    color: 'var(--color-text-muted)',
    padding: '20px 20px 12px',
  },
  sidebarList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    padding: '0 12px 20px',
  },
  sidebarItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    width: '100%',
    padding: '10px 14px',
    borderRadius: '10px',
    border: 'none',
    fontSize: '13px',
    cursor: 'pointer',
    fontFamily: 'inherit',
    textAlign: 'left',
    transition: 'all 0.15s ease',
  },
  fab: {
    position: 'fixed',
    bottom: '32px',
    right: '32px',
    width: '56px',
    height: '56px',
    borderRadius: '28px',
    border: 'none',
    backgroundColor: 'var(--color-secondary)',
    boxShadow: '0 8px 24px rgba(41,82,204,0.35)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 50,
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  },
  fabBadge: {
    position: 'absolute',
    top: '-2px',
    right: '-2px',
    backgroundColor: 'var(--color-danger)',
    color: 'var(--color-surface)',
    fontSize: '11px',
    fontWeight: 700,
    borderRadius: '12px',
    minWidth: '22px',
    height: '22px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 5px',
    boxShadow: '0 2px 6px rgba(234,67,53,0.4)',
  },
};

const S = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    overflow: 'hidden',
    position: 'relative',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  ubicacionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '48px 24px',
    textAlign: 'center',
    flex: 1,
  },
  ubicacionIcon: {
    width: '88px',
    height: '88px',
    borderRadius: '50%',
    backgroundColor: 'var(--color-bg-hover)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '24px',
  },
  ubicacionTitle: {
    fontSize: '20px',
    fontWeight: 700,
    color: 'var(--color-primary)',
    margin: '0 0 8px',
  },
  ubicacionSub: {
    fontSize: '14px',
    color: 'var(--color-text-secondary)',
    lineHeight: 1.5,
    maxWidth: '280px',
    margin: '0 0 24px',
  },
  ubicacionError: {
    fontSize: '13px',
    color: 'var(--color-danger)',
    backgroundColor: 'var(--color-danger-light)',
    padding: '10px 16px',
    borderRadius: '12px',
    marginBottom: '16px',
    maxWidth: '300px',
  },
  ubicacionButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
    maxWidth: '300px',
  },
  ubicacionBtnPrimary: {
    padding: '14px 24px',
    borderRadius: '14px',
    border: 'none',
    backgroundColor: 'var(--color-secondary)',
    color: 'var(--color-surface)',
    fontSize: '15px',
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    transition: 'opacity 0.2s',
  },
  ubicacionBtnSecondary: {
    padding: '14px 24px',
    borderRadius: '14px',
    border: '1.5px solid var(--color-secondary)',
    backgroundColor: 'var(--color-surface)',
    color: 'var(--color-secondary)',
    fontSize: '15px',
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  },

  seleccionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '32px 20px',
    textAlign: 'center',
    flex: 1,
  },
  direccionesList: {
    width: '100%',
    maxWidth: '380px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  direccionCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    padding: '14px 16px',
    backgroundColor: 'var(--color-surface)',
    borderRadius: '16px',
    border: '1px solid var(--color-border)',
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%',
    fontFamily: 'inherit',
    transition: 'box-shadow 0.15s',
  },
  direccionCardIcon: {
    width: '44px',
    height: '44px',
    borderRadius: '12px',
    backgroundColor: 'var(--color-bg-hover)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  direccionCardInfo: { flex: 1, minWidth: 0 },
  direccionCardNombre: {
    fontSize: '14px',
    fontWeight: 600,
    color: 'var(--color-primary)',
    marginBottom: '2px',
  },
  direccionCardText: {
    fontSize: '12px',
    color: 'var(--color-text-secondary)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  direccionCardSeleccionada: {
    borderColor: 'var(--color-danger)',
    backgroundColor: '#fef7f7',
    boxShadow: '0 0 0 1px var(--color-danger)',
  },
  direccionCardIconSeleccionada: {
    width: '44px',
    height: '44px',
    borderRadius: '12px',
    backgroundColor: 'var(--color-danger-light)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  direccionCardDeleteHint: { fontSize: '11px', fontWeight: 600, color: 'var(--color-danger)' },
  deleteBar: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 14px',
    backgroundColor: 'var(--color-danger-light)',
    borderRadius: '12px',
    border: '1px solid #f5c6cb',
  },
  deleteBarText: { flex: 1, fontSize: '12px', fontWeight: 600, color: 'var(--color-danger)' },
  deleteBarBtnCancel: {
    padding: '6px 14px',
    borderRadius: '8px',
    border: '1px solid #f5c6cb',
    backgroundColor: 'var(--color-surface)',
    color: 'var(--color-text-secondary)',
    fontSize: '12px',
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  deleteBarBtnConfirm: {
    padding: '6px 14px',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: 'var(--color-danger)',
    color: 'var(--color-surface)',
    fontSize: '12px',
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  nuevaDireccionBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '14px',
    borderRadius: '16px',
    border: '2px dashed var(--color-secondary)',
    backgroundColor: '#F8FAFF',
    color: 'var(--color-secondary)',
    fontSize: '15px',
    fontWeight: 600,
    cursor: 'pointer',
    width: '100%',
    fontFamily: 'inherit',
  },
  ubicacionBtnSmall: { background: 'none', border: 'none', cursor: 'pointer', padding: '6px' },
  mapOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '20px',
  },
  mapModal: {
    backgroundColor: 'var(--color-surface)',
    borderRadius: '20px',
    padding: '20px',
    width: '100%',
    maxWidth: '450px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
  },
  mapHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
  },
  mapClose: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: 'var(--color-text-secondary)',
    padding: '4px',
  },
  mapActions: { display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '12px' },
  mapBtnCancel: {
    padding: '10px 20px',
    borderRadius: '10px',
    border: '1px solid var(--color-border)',
    backgroundColor: 'var(--color-surface)',
    color: 'var(--color-text-secondary)',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  mapBtnConfirm: {
    padding: '10px 20px',
    borderRadius: '10px',
    border: 'none',
    backgroundColor: 'var(--color-secondary)',
    color: 'var(--color-surface)',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  direccionInput: {
    width: '100%',
    padding: '10px 14px',
    borderRadius: '12px',
    border: '1px solid var(--color-border)',
    fontSize: '14px',
    outline: 'none',
    backgroundColor: 'var(--color-bg)',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
  },

  catHeader: {
    flexShrink: 0,
    backgroundColor: 'var(--color-surface)',
    padding: '16px 20px 0',
    borderBottom: '1px solid #F0F0F0',
  },
  searchRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '10px',
    maxWidth: '640px',
  },
  searchBox: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: 'var(--color-bg)',
    borderRadius: '14px',
    padding: '10px 14px',
    border: '1px solid var(--color-border)',
  },
  searchInput: {
    flex: 1,
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    fontSize: '14px',
    fontFamily: 'inherit',
  },
  searchClear: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: 'var(--color-text-muted)',
    padding: '2px',
    display: 'flex',
  },
  sedeInfo: { display: 'flex', alignItems: 'center', gap: '6px', padding: '4px 0 10px' },
  cambiarBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '11px',
    color: 'var(--color-secondary)',
    fontWeight: 500,
    padding: 0,
  },
  deptoChips: {
    display: 'flex',
    gap: '8px',
    overflowX: 'auto',
    padding: '0 0 10px',
    WebkitOverflowScrolling: 'touch',
    scrollbarWidth: 'none',
  },
  deptoChip: {
    padding: '8px 16px',
    borderRadius: '20px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '13px',
    whiteSpace: 'nowrap',
    transition: 'all 0.2s',
    fontFamily: 'inherit',
    flexShrink: 0,
  },
  grupoChips: {
    display: 'flex',
    gap: '6px',
    overflowX: 'auto',
    padding: '0 0 10px',
    flexWrap: 'wrap',
  },
  grupoChip: {
    padding: '6px 14px',
    borderRadius: '16px',
    border: '1px solid var(--color-border)',
    cursor: 'pointer',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    fontWeight: 500,
    fontFamily: 'inherit',
    transition: 'all 0.15s',
  },

  grid: { padding: '16px 20px', flex: 1, minHeight: 0, overflowY: 'auto' },
  loadingState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px 0',
    gap: '12px',
  },
  spinner: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    border: '3px solid var(--color-border)',
    borderTop: '3px solid var(--color-secondary)',
    animation: 'spin 0.8s linear infinite',
  },
  spinnerSmall: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    border: '2px solid var(--color-border)',
    borderTop: '2px solid var(--color-secondary)',
    animation: 'spin 0.8s linear infinite',
    margin: '0 auto',
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px 0',
  },

  productGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(170px, 1fr))',
    gap: '12px',
  },
  productCard: {
    backgroundColor: 'var(--color-surface)',
    borderRadius: '16px',
    padding: '12px',
    border: '1px solid #F0F0F0',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    transition: 'box-shadow 0.18s ease, transform 0.18s ease, border-color 0.18s ease',
    position: 'relative',
    fontFamily: 'inherit',
    width: '100%',
  },
  productImage: {
    width: '96px',
    height: '96px',
    borderRadius: '12px',
    backgroundColor: 'var(--color-bg)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '8px',
    overflow: 'hidden',
  },
  productImg: { width: '100%', height: '100%', objectFit: 'contain', padding: '6px' },
  productInfo: { width: '100%', display: 'flex', flexDirection: 'column', flex: 1 },
  productName: {
    fontSize: '12px',
    fontWeight: 600,
    color: 'var(--color-primary)',
    lineHeight: 1.3,
    marginBottom: '2px',
    wordBreak: 'break-word',
  },
  productDesc: {
    fontSize: '11px',
    color: 'var(--color-text-secondary)',
    lineHeight: 1.3,
    marginBottom: '4px',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    wordBreak: 'break-word',
  },
  productPrice: { fontSize: '14px', fontWeight: 700, color: 'var(--color-secondary)', marginTop: 'auto' },
  productPriceBs: { fontSize: '11px', color: 'var(--color-text-secondary)' },
  productPriceOculto: { fontSize: '12px', fontWeight: 600, color: 'var(--color-text-muted)', marginTop: 'auto' },
  stockBadge: { fontSize: '10px', fontWeight: 500, marginTop: '4px' },
  pesableTag: {
    position: 'absolute',
    top: '6px',
    right: '6px',
    fontSize: '9px',
    fontWeight: 600,
    backgroundColor: '#fef7e0',
    color: '#b06000',
    padding: '2px 6px',
    borderRadius: '6px',
  },

  productList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  productListItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '10px 12px',
    backgroundColor: 'var(--color-surface)',
    borderRadius: '12px',
    border: '1px solid #F0F0F0',
    cursor: 'pointer',
    fontFamily: 'inherit',
    width: '100%',
    textAlign: 'left',
    position: 'relative',
  },
  productListImg: {
    width: '52px',
    height: '52px',
    borderRadius: '10px',
    backgroundColor: 'var(--color-bg)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    flexShrink: 0,
    position: 'relative',
  },
  productListInfo: {
    flex: 1,
    minWidth: 0,
  },
  productListName: {
    fontSize: '13px',
    fontWeight: 600,
    color: 'var(--color-primary)',
    lineHeight: 1.3,
    marginBottom: '2px',
    wordBreak: 'break-word',
  },
  productListDesc: {
    fontSize: '11px',
    color: 'var(--color-text-muted)',
    lineHeight: 1.3,
    marginBottom: '2px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  productListPrice: {
    fontSize: '14px',
    fontWeight: 700,
    color: 'var(--color-primary)',
    whiteSpace: 'nowrap',
    textAlign: 'right',
  },
  productListPriceOculto: {
    fontSize: '12px',
    fontWeight: 600,
    color: 'var(--color-text-muted)',
    whiteSpace: 'nowrap',
    textAlign: 'right',
  },
  productListPriceBs: {
    fontSize: '11px',
    color: 'var(--color-text-muted)',
    whiteSpace: 'nowrap',
    textAlign: 'right',
  },
  productListStock: {
    fontSize: '10px',
    fontWeight: 500,
    textAlign: 'right',
    marginTop: '2px',
  },
  productListActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '2px',
    flexShrink: 0,
    minWidth: '70px',
  },
  vistaToggle: {
    display: 'flex',
    gap: '2px',
    backgroundColor: 'var(--color-bg)',
    borderRadius: '10px',
    padding: '3px',
  },
  vistaToggleBtn: {
    padding: '5px 7px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'inherit',
    color: 'var(--color-text-muted)',
    backgroundColor: 'transparent',
    transition: 'background 0.15s, color 0.15s',
  },
  vistaToggleBtnActive: {
    padding: '5px 7px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'inherit',
    backgroundColor: 'var(--color-surface)',
    color: 'var(--color-primary)',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },

  cartFloat: {
    position: 'fixed',
    bottom: 'calc(92px + env(safe-area-inset-bottom, 0px))',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: 'var(--color-primary)',
    borderRadius: '24px',
    padding: '10px 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    boxShadow: '0 4px 20px rgba(11,26,74,0.35)',
    cursor: 'pointer',
    zIndex: 50,
    width: 'fit-content',
  },
  cartCount: {
    backgroundColor: 'var(--color-secondary)',
    color: 'var(--color-surface)',
    fontSize: '11px',
    fontWeight: 700,
    borderRadius: '10px',
    padding: '2px 7px',
    minWidth: '20px',
    textAlign: 'center',
  },
  cartTotal: { color: 'var(--color-surface)', fontSize: '14px', fontWeight: 700 },

  detailOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    zIndex: 1000,
  },
  detailModal: {
    backgroundColor: 'var(--color-surface)',
    borderRadius: '20px 20px 0 0',
    padding: '20px 20px 28px',
    width: '100%',
    maxWidth: '480px',
    maxHeight: '90vh',
    overflowY: 'auto',
    position: 'relative',
  },
  detailClose: {
    position: 'absolute',
    top: '16px',
    right: '16px',
    background: 'var(--color-bg)',
    border: 'none',
    borderRadius: '50%',
    width: '36px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: 'var(--color-text-secondary)',
    zIndex: 2,
  },
  detailShare: {
    position: 'absolute',
    top: '16px',
    right: '60px',
    background: '#25D366',
    border: 'none',
    borderRadius: '50%',
    width: '36px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: '#fff',
    zIndex: 2,
  },
  detailImage: {
    width: '100%',
    height: '200px',
    borderRadius: '14px',
    backgroundColor: 'var(--color-bg)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '16px',
    overflow: 'hidden',
  },
  detailImg: { width: '100%', height: '100%', objectFit: 'contain' },
  detailBody: {},
  detailName: {
    margin: '0 0 6px',
    fontSize: '18px',
    fontWeight: 700,
    color: 'var(--color-primary)',
    lineHeight: 1.3,
    paddingRight: '40px',
  },
  detailDesc: {
    fontSize: '13px',
    color: 'var(--color-text-secondary)',
    lineHeight: 1.5,
    margin: '0 0 12px',
  },
  detailPrices: { display: 'flex', alignItems: 'baseline', gap: '10px', marginBottom: '12px' },
  detailPriceUsd: { fontSize: '22px', fontWeight: 700, color: 'var(--color-secondary)' },
  detailPriceBs: { fontSize: '14px', color: 'var(--color-text-secondary)' },
  detailPrecioOculto: { fontSize: '14px', fontWeight: 600, color: 'var(--color-text-muted)' },
  detailTags: { display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '16px' },
  tagYellow: {
    fontSize: '11px',
    fontWeight: 600,
    padding: '4px 10px',
    borderRadius: '8px',
    backgroundColor: '#fef7e0',
    color: '#b06000',
  },
  tagGreen: { fontSize: '11px', fontWeight: 600, padding: '4px 10px', borderRadius: '8px' },
  detailMeta: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '12px',
    backgroundColor: 'var(--color-bg)',
    borderRadius: '12px',
    marginBottom: '16px',
  },
  metaItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  metaLabel: { fontSize: '12px', color: 'var(--color-text-secondary)' },
  metaValue: { fontSize: '12px', fontWeight: 600, color: 'var(--color-primary)' },
  detailActions: { display: 'flex', flexDirection: 'column', gap: '12px' },
  cantSelector: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    padding: '8px 0',
  },
  cantBtn: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    border: '1.5px solid var(--color-border)',
    backgroundColor: 'var(--color-surface)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--color-primary)',
  },
  cantValue: {
    fontSize: '16px',
    fontWeight: 600,
    color: 'var(--color-primary)',
    minWidth: '60px',
    textAlign: 'center',
  },
  addBtn: {
    padding: '14px',
    borderRadius: '14px',
    border: 'none',
    backgroundColor: 'var(--color-secondary)',
    color: 'var(--color-surface)',
    fontSize: '15px',
    fontWeight: 700,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    transition: 'opacity 0.2s',
  },
  confirmarPedidoBtn: {
    width: '100%',
    padding: '14px',
    borderRadius: '14px',
    border: 'none',
    backgroundColor: 'var(--color-success)',
    color: 'var(--color-surface)',
    fontSize: '15px',
    fontWeight: 700,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  },

  cartItemRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '10px 0',
    borderBottom: '1px solid #F0F0F0',
  },
  cartCantBtn: {
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    border: '1px solid var(--color-border)',
    backgroundColor: 'var(--color-bg)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--color-primary)',
    fontSize: '12px',
  },
  cartCantBtnLarge: {
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    border: '1px solid var(--color-border)',
    backgroundColor: 'var(--color-bg)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  cartMobileOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.4)',
    zIndex: 2000,
  },
  cartMobilePanel: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'var(--color-surface)',
    borderRadius: '20px 20px 0 0',
    maxHeight: '85vh',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 2001,
    boxShadow: '0 -4px 32px rgba(0,0,0,0.15)',
    overflow: 'hidden',
  },

  toastFloating: {
    position: 'fixed',
    bottom: '100px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: 'var(--color-primary)',
    color: 'var(--color-surface)',
    padding: '10px 20px',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: 500,
    zIndex: 2000,
    whiteSpace: 'nowrap',
    boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
    animation: 'toastIn 0.3s ease',
  },
};

const M = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
    padding: '20px',
  },
  modal: {
    backgroundColor: 'var(--color-surface)',
    borderRadius: '20px',
    padding: '24px',
    width: '100%',
    maxWidth: '380px',
    boxShadow: '0 16px 48px rgba(0,0,0,0.2)',
  },
  nombreInput: {
    width: '100%',
    padding: '12px 14px',
    borderRadius: '12px',
    border: '1px solid var(--color-border)',
    fontSize: '14px',
    outline: 'none',
    backgroundColor: 'var(--color-bg)',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
    marginBottom: '12px',
  },
  direccionPreview: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
    padding: '10px 14px',
    backgroundColor: 'var(--color-bg)',
    borderRadius: '10px',
  },
  btnCancel: {
    flex: 1,
    padding: '12px',
    borderRadius: '12px',
    border: '1px solid var(--color-border)',
    backgroundColor: 'var(--color-surface)',
    color: 'var(--color-text-secondary)',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  btnGuardar: {
    flex: 1,
    padding: '12px',
    borderRadius: '12px',
    border: 'none',
    backgroundColor: 'var(--color-secondary)',
    color: 'var(--color-surface)',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit',
    opacity: 1,
  },
};

export const cssAnimations = `
@keyframes spin { to { transform: rotate(360deg); } }
@keyframes spinRefresh { to { transform: rotate(360deg); } }
@keyframes toastIn { from { opacity: 0; transform: translateX(-50%) translateY(20px); } to { opacity: 1; transform: translateX(-50%) translateY(0); } }
@keyframes fabPulse { 0% { transform: scale(1); } 50% { transform: scale(1.35); } 100% { transform: scale(1); } }
`;

export { SD, S, M };
